import React from 'react';
import { AppButton } from '@/components/atoms';
import BottomBar from '@/components/organisms/Footer';

interface Props {
  onBulkPrint: () => void;
  onFormatPrint: () => void;
  onListPrint: () => void;
  /** 令和8年法改正 No 3 — blank 別紙様式5 slip. Independent of the print options. */
  onMonthlyStatementForm: () => void;
  isPrinting: boolean;
  isMonthlyStatementFormPrinting: boolean;
}

const InvoiceActionBar: React.FC<Props> = ({
  onBulkPrint,
  onFormatPrint,
  onListPrint,
  onMonthlyStatementForm,
  isPrinting,
  isMonthlyStatementFormPrinting,
}) => (
  <BottomBar
    variant="action"
    visible
    fixed
    left={
      <>
        <AppButton
          type="primary"
          onClick={onBulkPrint}
          loading={isPrinting}
          className="min-w-[100px] rounded"
        >
          印刷
        </AppButton>
        <AppButton
          type="default"
          onClick={onListPrint}
          loading={isPrinting}
          className="min-w-[100px] rounded"
        >
          一覧印刷
        </AppButton>
        <AppButton
          type="default"
          onClick={onFormatPrint}
          loading={isPrinting}
          className="min-w-[100px] rounded"
        >
          雛形印刷
        </AppButton>
        <AppButton
          type="default"
          onClick={onMonthlyStatementForm}
          loading={isMonthlyStatementFormPrinting}
          className="min-w-[100px] rounded"
        >
          月別明細書発行依頼書印刷
        </AppButton>
      </>
    }
  />
);

export default InvoiceActionBar;
